import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/translation/editor/translation.suggestSet.mutation.gql"
import type {
  TranslationSuggestSetMutation,
  TranslationSuggestSetMutationVariables,
} from "@/v2-backoffice-client/translation/editor/__types__/translation.suggestSet.mutation"

type Options = MutationHookOptions<
  TranslationSuggestSetMutation,
  TranslationSuggestSetMutationVariables
>

export function useTranslationSuggestSetMutation(options?: Options) {
  return useMutation<
    TranslationSuggestSetMutation,
    TranslationSuggestSetMutationVariables
  >(mutation, options)
}
